import { i18n } from "i18next"
import React, { useLayoutEffect } from "react"
import { I18nextProvider } from "react-i18next"

import en from "hooks/agent/locale/translations/en.json"
import es from "hooks/agent/locale/translations/es.json"
import pt from "hooks/agent/locale/translations/pt.json"

type Props = {
	children: React.ReactNode
	i18n: i18n
}

export const AgentProvider = ({ children, i18n }: Props) => {
	useLayoutEffect(() => {
		i18n.addResourceBundle("es", "agent", es.agent)
		i18n.addResourceBundle("en", "agent", en.agent)
		i18n.addResourceBundle("pt", "agent", pt.agent)
	}, [])

	return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}
